import * as React from 'react';
import { getIntrinsicElementProps, slot } from '@fluentui/react-components';
import { Shield16Regular, Shield16Filled, ShieldLock16Regular, ShieldLock16Filled } from '@fluentui/react-icons';
/**
 * Create the state required to render SensitivityIcon.
 *
 * The returned state can be modified with hooks such as useSensitivityIconStyles_unstable,
 * before being passed to renderSensitivityIcon_unstable.
 *
 * @param props - props from this instance of SensitivityIcon
 * @param ref - reference to root HTMLElement of SensitivityIcon
 */
export const useSensitivityIcon_unstable = (props, ref) => {
  var _state_foregroundIcon, _state_backgroundIcon;
  const {
    fillColor,
    withLock = false
  } = props;
  const state = {
    components: {
      root: 'span',
      foregroundIcon: 'span',
      backgroundIcon: 'span'
    },
    root: slot.always(getIntrinsicElementProps('span', {
      ref,
      ...props
    }), {
      elementType: 'span'
    }),
    foregroundIcon: slot.optional(props.foregroundIcon, {
      renderByDefault: true,
      elementType: 'span'
    }),
    backgroundIcon: slot.optional(props.backgroundIcon, {
      renderByDefault: true,
      elementType: 'span'
    })
  };
  const iconProvided = !!React.Children.count((_state_foregroundIcon = state.foregroundIcon) === null || _state_foregroundIcon === void 0 ? void 0 : _state_foregroundIcon.children) || !!React.Children.count((_state_backgroundIcon = state.backgroundIcon) === null || _state_backgroundIcon === void 0 ? void 0 : _state_backgroundIcon.children);
  if (!iconProvided) {
    if (state.foregroundIcon) {
      state.foregroundIcon.children = withLock ? /*#__PURE__*/React.createElement(ShieldLock16Regular, null) : /*#__PURE__*/React.createElement(Shield16Regular, null);
    }
    if (state.backgroundIcon) {
      state.backgroundIcon.children = withLock ? /*#__PURE__*/React.createElement(ShieldLock16Filled, {
        primaryFill: fillColor
      }) : /*#__PURE__*/React.createElement(Shield16Filled, {
        primaryFill: fillColor
      });
    }
  }
  return state;
};
//# sourceMappingURL=useSensitivityIcon.js.map